<div class="d-flex">
    <div class="back-navigation" (click)="onClickBackButton()">
        <i class="bi bi-arrow-left"></i>
        <span class="title">{{ backTitle | translate}}</span>
    </div>
    @if(action) {
        <div class="back-navigation" (click)="onClickActionButton()">
            @if(actionIconClass) {
                <i [class]="actionIconClass"></i>
            }
            <span class="title">{{ action | translate}}</span>
        </div>
    }    
</div>